import { connect } from 'react-redux'
import UploadAvatar from './upload-avatar'
import { uploadAvatar } from '../../../../../../stores/user-details/user-details.actions'
import { withRouter } from 'react-router'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = (dispatch, { match }) => ({
  onChange: files =>
    dispatch(uploadAvatar(match.params.id, files[0])).catch(errorHandler)
})

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(UploadAvatar)
)
